let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3bpyj")).then(() => parcelRequire('2RVA3'));